module.exports = __webpack_public_path__ + "img/about.a63902c.webp";